<template>
  <div class="animated fadeIn">
    <b-tabs id="persontabs" v-model="tabIndex">

      <!-- Commented out because _for now_ we're going to assume the organization from your User Context -->
      <!-- <b-tab
        v-if="chooseOrganization"
        title="Organization"
        v-show="authenticatedUserMemberships.length > 1"
        :active="chooseOrganization && authenticatedUserMemberships.length > 1"
      >
        <b-card style="border: none">
            <b-row>
              <p>Choose the owning organization:</p>
              <b-col md="6" sm="12">
                <b-list-group v-for="umo in authenticatedUserMemberships" :key="umo.id" flush>
                  <b-list-group-item :active="isActiveOrganization(umo)">
                    <a href="" @click.prevent="handleOwningOrganizationSelection(umo)">{{ _.get(umo, 'morganization.title', 'Unknown Organization') }}</a>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
        </b-card>
      </b-tab> -->
      <!-- <b-tab title="Biographical" :active="!chooseOrganization || ( chooseOrganization && authenticatedUserMemberships.length === 1 )"> -->

      <b-tab title="Biographical">
        <b-card style="border: none">
            <b-row>
              <b-col md="6" sm="12">

                <b-form-group label-size='lg' label-class='addpersonlabel' label-for='b_first_name' :horizontal='false'>
                  <template slot='label'>
                    First Name <span class='text-danger'>*</span>
                  </template>
                  <b-form-input data-vv-name="person.b_first_name" v-validate="'required'" data-vv-as="First Name" size="lg" id='b_first_name' v-model='person.b_first_name'></b-form-input>
                  <span v-show="inputValidationErrors.has('person.b_first_name')" class="text-info">{{ inputValidationErrors.first('person.b_first_name') }}</span>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' label-for='b_last_name' :horizontal='false'>
                  <template slot='label'>
                    Last Name <span class='text-danger'>*</span>
                  </template>
                  <b-form-input required size="lg" v-validate="'required'" data-vv-name="person.b_last_name" data-vv-as="Last Name" id='b_last_name' v-model='person.b_last_name'></b-form-input>
                  <span v-show="inputValidationErrors.has('person.b_last_name')" class="text-info">{{ inputValidationErrors.first('person.b_last_name') }}</span>
                </b-form-group>
                <b-form-group label-size='lg' label-class='nicknamelabel' label='Nickname or Other Identifier' label-for='b_nickname' :horizontal='false'>
                  <b-form-input required size="lg" data-vv-name="person.b_nickname" data-vv-as="Nickname" id='b_nickname' v-model='person.b_nickname'></b-form-input>
                  <span v-show="inputValidationErrors.has('person.b_nickname')" class="text-info">{{ inputValidationErrors.first('person.b_nickname') }}</span>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Birthdate' label-for='b_birthdate' :horizontal='false'>
                <datepicker
                  input-class="form-control-lg"
                  initial-view="year"
                  v-model='person.b_birthdate'
                  id="b_birthdate"
                  placeholder="Select Date"
                  :format="this.$dateFormatter"
                  :disabled-dates="{ from: new Date() }"
                  clear-button
                >
                </datepicker>
                </b-form-group>
                <b-form-group label-size='lg' label-class='nicknamelabel' label='Approximate Age' label-for='b_approximate_age' :horizontal='false'>
                  <p style="margin-top:-20px; font-style: italic;" >Please enter a numerical value for the person's actual or approximate age, in years, if Birthdate is left blank.</p>
                  <b-form-input type='number' step="1"  :formatter="formatter" size="lg" data-vv-name="person.b_approximate_age" data-vv-as="Approximate Age" id='b_approximate_age' v-model='person.b_approximate_age'></b-form-input>
                  <span v-show="inputValidationErrors.has('person.b_approximate_age')" class="text-info">{{ inputValidationErrors.first('person.b_approximate_age') }}</span>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Race' label-for='b_race' :horizontal='false'>
                  <b-form-select size="lg" :options="race_options" id='b_race' v-model='person.b_race' data-vid="person.b_race">
                  </b-form-select>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' v-if="person.b_race === 'Other'" label-for='b_race_otherText' :horizontal='false'>
                   <b-form-input data-vv-name="person.b_race_otherText" v-validate="person.b_race === 'Other' ? 'required' : '' " data-vv-as="Other Race" size="lg" id='b_race_otherText' v-model='person.b_race_otherText'></b-form-input>
                   <span v-show="inputValidationErrors.has('person.b_race_otherText')" class="text-info">{{ inputValidationErrors.first('person.b_race_otherText') }}</span>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Ethnicity' label-for='b_ethnicity' :horizontal='false'>
                  <b-form-select size="lg" :options="ethnicity_options" id='b_ethnicity' v-model='person.b_ethnicity' data-vid="person.b_ethnicity">
                  </b-form-select>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' v-if="person.b_ethnicity === 'Other'" label-for='b_ethnicity_otherText' :horizontal='false'>
                   <b-form-input data-vv-name="person.b_ethnicity_otherText" v-validate="person.b_ethnicity === 'Other' ? 'required' : '' " data-vv-as="Other Ethnicity" size="lg" id='b_ethnicity_otherText' v-model='person.b_ethnicity_otherText'></b-form-input>
                   <span v-show="inputValidationErrors.has('person.b_ethnicity_otherText')" class="text-info">{{ inputValidationErrors.first('person.b_ethnicity_otherText') }}</span>
                </b-form-group>
              </b-col>
              <b-col md="6" sm="12">
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Gender Assigned at Birth' label-for='b_gender' :horizontal='false'>
                  <b-form-select size="lg" :options="gender_options" id='b_gender' v-model='person.b_gender'>
                  </b-form-select>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' v-if="person.b_gender === 'Other'" label-for='b_gender_otherText' :horizontal='false'>
                   <b-form-input data-vv-name="person.b_gender_otherText" v-validate="person.b_gender === 'Other' ? 'required' : '' " data-vv-as="Other Gender" size="lg" id='b_gender_otherText' v-model='person.b_gender_otherText'></b-form-input>
                   <span v-show="inputValidationErrors.has('person.b_gender_otherText')" class="text-info">{{ inputValidationErrors.first('person.b_gender_otherText') }}</span>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Current Gender Identity' label-for='b_gender_identity' :horizontal='false'>
                  <b-form-select size="lg" :options="gender_identity" id='b_gender' v-model='person.b_gender_identity'>
                  </b-form-select>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' v-if="person.b_gender_identity === 'Other'" label-for='b_gender_identity_otherText' :horizontal='false'>
                   <b-form-input data-vv-name="person.b_gender_identity_otherText" v-validate="person.b_gender === 'Other' ? 'required' : '' " data-vv-as="Other Gender Identity" size="lg" id='b_gender_identity_otherText' v-model='person.b_gender_identity_otherText'></b-form-input>
                   <span v-show="inputValidationErrors.has('person.b_gender_identity_otherText')" class="text-info">{{ inputValidationErrors.first('person.b_gender_identity_otherText') }}</span>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Sexual Orientation' label-for='b_orientation' :horizontal='false'>
                  <b-form-select size="lg" :options="orientation_options" id='b_orientation' v-model='person.b_orientation'>
                  </b-form-select>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' v-if="person.b_orientation === 'Other'" label-for='b_orientation_otherText' :horizontal='false'>
                   <b-form-input data-vv-name="person.b_orientation_otherText" v-validate="person.b_orientation === 'Other' ? 'required' : '' " data-vv-as="Other Orientation" size="lg" id='b_orientation_otherText' v-model='person.b_orientation_otherText'></b-form-input>
                   <span v-show="inputValidationErrors.has('person.b_orientation_otherText')" class="text-info">{{ inputValidationErrors.first('person.b_orientation_otherText') }}</span>
                </b-form-group>
                 <!-- Grade Level -->
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Education Level' label-for='p_grade_level' :horizontal='false'>
                  <b-form-select size="lg" :options="gradeLevelOptions" id='p_grade_level' v-model='person.p_grade_level'></b-form-select>
                </b-form-group>
                <!-- Education Type -->
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Education Type' label-for='p_education_type' :horizontal='false'>
                  <b-form-select size="lg" :options="educationTypes" id='p_education_type' v-model='person.p_education_type'></b-form-select>
                </b-form-group>
                <!-- Disability -->
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Disability' label-for='b_disability' :horizontal='false'>
                  <b-form-select size="lg" :options="disabilityOptions" id='b_disability' v-model='person.b_disability'></b-form-select>
                </b-form-group>
                <b-form-group
                  label-size='lg'
                  label-class='addpersonlabel'
                  label='Disability Description'
                  label-for='b_disability_otherText'
                  :horizontal='false'
                  v-if="person.b_disability === 'Other'">
                  <b-form-input
                    size="lg"
                    v-model="person.b_disability_otherText"
                    v-if="person.b_disability === 'Other'"
                    data-vv-name="Other"
                    v-validate="'required'"
                    data-vv-as="Other">
                  </b-form-input>
                  <span v-show="inputValidationErrors.has('b_disability_otherText')" class="text-info">{{ inputValidationErrors.first('b_disability_otherText') }}</span>
                </b-form-group>
                <!-- Immigration -->
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Immigration Status' label-for='b_immigration_category' :horizontal='false'>
                  <b-form-select size="lg" :options="immigration_options" id='b_immigration_category' v-model='person.b_immigration_category'></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-tab>

      <b-tab title="Victim Information">
        <PersonVictimInfoForm
          v-for="(info, index) in personVictimInfo"
          :key="index"
          :victimInfo="info"
          :stateName="stateName"
          :compiledVictimInfo="compiledVictimInfo"
          :isCareCoordinator="isCareCoordinator"
          :isOrgManager="isOrgManager"
          :getNonUSCountries="getNonUSCountries"
        />
        <PersonVictimInfoForm
          v-for="(info, index) in newVictimInfo"
          :key="`new-${index}`"
          :victimInfo="info"
          :stateName="stateName"
          :compiledVictimInfo="compiledVictimInfo"
          :isCareCoordinator="isCareCoordinator"
          :isOrgManager="isOrgManager"
          :getNonUSCountries="getNonUSCountries"
        />
        <div v-if="isAllowedToAddTypeOfTrafficking" class='card noBoxShadow flexRowEnd'>
          <b-button @click="addAnotherTypeOfTrafficking" variant="primary">Add Another Type of Trafficking & Exploitation</b-button>
        </div>
      </b-tab>

      <b-tab title="Services" v-if="person.b_confirmed">
        <b-card class='width100'>
          <b-row>
            <b-col md='6'>
              <b-form-group label-size='lg' label-class='addpersonlabel' label='Program Entry Date' label-for='s_program_entry_date' :horizontal='false'>
                <datepicker
                  ref="s_program_entry_dateRef"
                  input-class="form-control-lg"
                  initial-view="year"
                  v-model='person.s_program_entry_date'
                  id="s_program_entry_date"
                  placeholder="Select Date"
                  :format="this.$dateFormatter"
                  :disabled-dates="{ from: new Date() }"
                  clear-button
                >
                </datepicker>
              </b-form-group>
              <b-form-group label-size='lg' label-class='addpersonlabel' label='Program Discharge Date' label-for='s_program_discharge_date' :horizontal='false'>
                <datepicker
                  input-class="form-control-lg"
                  initial-view="year"
                  v-model='person.s_program_discharge_date'
                  id="s_program_discharge_date"
                  placeholder="Select Date"
                  :format="this.$dateFormatter"
                  :disabled-dates="{ to: new Date(person.s_program_entry_date), from: new Date() }"
                  :max="new Date()"
                  clear-button
                >
                </datepicker>
              </b-form-group>
              <!-- Discharge -->
              <b-form-group label-size='lg' label-class='addpersonlabel' label='Discharge Reason' label-for='s_discharge_reason' :horizontal='false' v-if="person.s_program_discharge_date">
                <b-form-select size="lg" :options="discharge_options" id='s_discharge_reason' v-model='person.s_discharge_reason'></b-form-select>
              </b-form-group>
              <b-form-group
                label-size='lg'
                label-class='addpersonlabel'
                label='Discharge Description'
                label-for='s_discharge_reason_otherText'
                :horizontal='false'
                v-if="person.s_discharge_reason === 'Other'">
                <b-form-input
                  size="lg"
                  v-model="person.s_discharge_reason_otherText"
                  v-if="person.s_discharge_reason === 'Other'"
                  data-vv-name="Other"
                  v-validate="'required'"
                  data-vv-as="Other">
                </b-form-input>
                <span v-show="inputValidationErrors.has('s_discharge_reason_otherText')" class="text-info">{{ inputValidationErrors.first('s_discharge_reason_otherText') }}</span>
              </b-form-group>
              <!-- Services Provided -->
              <b-form-group stacked
                  label-size='lg'
                  label-class='font-weight-bold'
                  label='Services Provided During Program Enrollment'
              > 
                <info-icon id="tooltip-target-2" style="position:relative; top: -37px; margin-left: 444px; cursor:pointer;" @click=handleServicesModal />
                <p style="margin-top:-20px; font-style: italic;">Select all services that were provided to the victim during the program enrollment period.</p>
                <!-- <b-form-checkbox-group v-model="person.selectedServices" :options="services_provided" value-field="value" text-field="text" stacked> -->
                <b-alert
                  :show="!person.s_program_entry_date"
                  ref="servicesWithNoEntryDateWarnRef"
                  variant="warning"
                  >
                  <span>Please enter a Program Entry Date.</span>
                </b-alert>
                <b-form-checkbox-group :disabled="!person.s_program_entry_date" v-model="selectedServices" :options="services_provided" value-field="value" text-field="text" stacked class='checkboxGroup'>
                  <!-- <b-form-checkbox
                      size="lg"
                      v-for="(option, id) in services_provided"
                      :key="id"
                      value={{option.value}}
                  >
                      {{ option.text }}
                  </b-form-checkbox> -->
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>

      <b-tab title="Supplemental Information">
        <b-card class='width100'>
          <b-row>
            <b-col md='6'>
            <b-form-group label-size='lg' label-class='addpersonlabel' label='PID#' label-for='p_pid' :horizontal='false'>
              <b-form-input size='lg' type='text' v-model='person.p_pid'></b-form-input>
            </b-form-group>
            <b-form-group
              label-size='lg'
              label-class='addpersonlabel'
              label='Presenting Offense'
              label-for='p_presenting_offense'
              :horizontal='false'>
              <b-form-select
                size="lg"
                :options="presentingOffenseOptions"
                id='p_presenting_offense'
                v-model='person.p_presenting_offense'>
              </b-form-select>
            </b-form-group>
            <b-form-group
              label-size='lg'
              label-class='addpersonlabel'
              label-for='p_presenting_offense_otherText'
              label='Presenting Offense Description'
              :horizontal='false'
              v-if="person.p_presenting_offense === 'Other'">
              <b-form-input
                size="lg"
                v-model="person.p_presenting_offense_otherText"
                data-vv-name="Other"
                v-validate="'required'"
                data-vv-as="Other">
              </b-form-input>
              <span v-show="inputValidationErrors.has('p_presenting_offense_otherText')" class="text-info">{{ inputValidationErrors.first('p_presenting_offense_otherText') }}</span>
            </b-form-group>
            <b-form-group label-size='lg' label-class='addpersonlabel' label='Street Name/Alias' label-for='p_street_name' :horizontal='false'><b-form-input size="lg" id='p_street_name' v-model='person.p_street_name'></b-form-input></b-form-group>
            <b-form-group label-size='lg' label-class='addpersonlabel' label='Last Home Location Description' label-for='p_last_home_location' :horizontal='false'><b-form-input size="lg" id='p_last_home_location' v-model='person.p_last_home_location'></b-form-input></b-form-group>

            <b-form-group label-size='lg' style="margin-left: 20px" label-class='addpersonlabel' label='Street' label-for='p_last_home_location_street' :horizontal='false'><b-form-input size="lg" id='p_last_home_location_street' v-model='person.p_last_home_location_street'></b-form-input></b-form-group>
            <b-form-group label-size='lg' style="margin-left: 20px" label-class='addpersonlabel' label='City' label-for='p_last_home_location_city' :horizontal='false'><b-form-input size="lg" id='p_last_home_location_city' v-model='person.p_last_home_location_city'></b-form-input></b-form-group>

            <b-form-group label-size='lg' style="margin-left: 20px" label-class='addpersonlabel' label='State' label-for='p_last_home_location_state' :horizontal='false'> <b-form-select size="lg" :options="mailingStateOptions()" id='p_last_home_location_state' v-model='person.p_last_home_location_state'></b-form-select></b-form-group>


            <b-form-group label-size='lg' style="margin-left: 20px" label-class='addpersonlabel' label='Zip' label-for='p_last_home_location_zip' :horizontal='false'><b-form-input size="lg" id='p_last_home_location_zip' v-model='person.p_last_home_location_zip'></b-form-input></b-form-group>

            <!-- Grade Level
            <b-form-group label-size='lg' label-class='addpersonlabel' label='Education Level' label-for='p_grade_level' :horizontal='false'>
              <b-form-select size="lg" :options="gradeLevelOptions" id='p_grade_level' v-model='person.p_grade_level'></b-form-select>
            </b-form-group>

            <b-form-group label-size='lg' label-class='addpersonlabel' label='Education Type' label-for='p_education_type' :horizontal='false'>
              <b-form-select size="lg" :options="educationTypes" id='p_education_type' v-model='person.p_education_type'></b-form-select>
            </b-form-group>

            <b-form-group label-size='lg' label-class='addpersonlabel' label='Disability' label-for='b_disability' :horizontal='false'>
              <b-form-select size="lg" :options="disabilityOptions" id='b_disability' v-model='person.b_disability'></b-form-select>
            </b-form-group>
            <b-form-group
              label-size='lg'
              label-class='addpersonlabel'
              label='Disability Description'
              label-for='b_disability_otherText'
              :horizontal='false'
              v-if="person.b_disability === 'Other'">
              <b-form-input
                size="lg"
                v-model="person.b_disability_otherText"
                v-if="person.b_disability === 'Other'"
                data-vv-name="Other"
                v-validate="'required'"
                data-vv-as="Other">
              </b-form-input>
              <span v-show="inputValidationErrors.has('Other')" class="text-info">{{ inputValidationErrors.first('Other') }}</span>
            </b-form-group> -->

            <!-- Country of Origin -->
            <b-form-group label-size='lg' label-class='addpersonlabel' label='Country of Origin' label-for='p_country_of_origin' :horizontal='false'>
              <b-form-select size="lg" :options="countries" id='p_country_of_origin' v-model='person.p_country_of_origin'></b-form-select>
            </b-form-group>

            <!-- Immigration Status -->
            <!-- <b-form-group label-size='lg' label-class='addpersonlabel' label="Immigration Status: Did the youth or the youth's parents immigrate to the US from another country?" label-for='p_imm_status' :horizontal='false'>
              <b-form-select size="lg" :options="yesNoUnknownOptions" id='p_imm_status' v-model='person.p_imm_status'></b-form-select>
            </b-form-group> -->

            <!-- Immigration Documentation -->
            <!-- <b-form-group label-size='lg' v-if="person.p_imm_status === 'Yes'" label-class='addpersonlabel' label="Is the youth or the youth's parents undocumented?" label-for='p_imm_doc' :horizontal='false'>
              <b-form-select data-vv-name="person.p_imm_doc" v-validate="person.p_imm_status === 'Yes' ? 'required' : ''" size="lg" data-vv-as="Immigration Documentation" :options="yesNoUnknownOptions" id='p_imm_doc' v-model='person.p_imm_doc'></b-form-select>
              <span v-show="inputValidationErrors.has('person.p_imm_doc')" class="text-info">{{ inputValidationErrors.first('person.p_imm_doc') }}</span>
            </b-form-group> -->

            <!-- Immigration Exploitation -->
            <!-- <b-form-group label-size='lg' v-if="person.p_imm_status === 'Yes'" label-class='addpersonlabel' label="Is the youth or the their parents immigration status related to the youth's exploitation?" label-for='p_imm_exp' :horizontal='false'>
              <b-form-select data-vv-name="person.p_imm_exp" v-validate="person.p_imm_status === 'Yes' ? 'required' : ''" size="lg" :options="yesNoUnknownOptions" id='p_imm_exp' data-vv-as="Immigration Exploitation" v-model='person.p_imm_exp'></b-form-select>
              <span v-show="inputValidationErrors.has('person.p_imm_exp')" class="text-info">{{ inputValidationErrors.first('person.p_imm_exp') }}</span>
            </b-form-group> -->

            <!-- Immigration Text -->
            <!-- <b-form-group label-size='lg' v-if="person.p_imm_status === 'Yes'" label-class='addpersonlabel' label="Please provide additional information relevant to immigration status and youth's exploitation (optional)." label-for='p_imm_text' :horizontal='false'>
              <b-form-textarea id="p_imm_text" v-model="person.p_imm_text"></b-form-textarea>
            </b-form-group> -->

            <!-- Poverty Line -->
            <b-form-group label-size='lg' label-class='addpersonlabel' label='Poverty Line' label-for='p_poverty_line' :horizontal='false'>
              <b-form-select size="lg" :options="povertyOptions" id='p_poverty_line' v-model='person.p_poverty_line'></b-form-select>
            </b-form-group>

            <!-- Forced Labor -->
            <b-form-group label-size='lg' label-class='addpersonlabel' label="Is the youth performing labor or services (not including sex) induced by force, fraud, or coercion?" label-for='p_forcedlabor' :horizontal='false'>
              <b-form-select size="lg" :options="yesNoUnknownOptions" id='p_forcedlabor' v-model='person.p_forcedlabor'></b-form-select>
            </b-form-group>

            <!-- Guardian -->
            <b-form-group label-size='lg' label-class='addpersonlabel' label='Guardian' label-for='p_guardian' :horizontal='false'>
              <b-form-select size="lg" :options="guardianOptions" id='p_guardian' v-model='person.p_guardian'></b-form-select>
            </b-form-group>
            <b-form-group
              label-size='lg'
              label-class='addpersonlabel'
              label='Guardian Description'
              label-for='p_guardian_otherText'
              :horizontal='false'
              v-if="person.p_guardian === 'Other'">
              <b-form-input
                size="lg"
                v-model="person.p_guardian_otherText"
                v-if="person.p_guardian === 'Other'"
                data-vv-name="Other"
                v-validate="'required'"
                data-vv-as="Other">
              </b-form-input>
              <span v-show="inputValidationErrors.has('p_guardian_otherText')" class="text-info">{{ inputValidationErrors.first('p_guardian_otherText') }}</span>
            </b-form-group>
            <br/>

            <!-- LE Called -->
            <b-form-group label-size='lg' label-class='addpersonlabel' flush class="pb-2 pl-1">
                <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success" v-model="person.p_le_called" true-value="Yes" false-value="" name="p_le_called">LE Called?</p-check>
            </b-form-group>

            <transition name="form-fade">
              <div class="sub-group" v-if="person.p_le_called === 'Yes'">
                <b-form-group label-size='lg' label-class='addpersonlabel' label='LE Call Date' label-for='p_le_call_date' :horizontal='false'>
                  <datepicker
                    input-class="form-control-lg"
                    initial-view="year"
                    v-model='person.p_le_call_date'
                    id="p_le_call_date"
                    placeholder="Select Date"
                    :format="this.$dateFormatter"
                    :disabled-dates="{ from: new Date() }"
                  ></datepicker>
                </b-form-group>

                <b-form-group
                  label-size='lg'
                  label="LE Agency"
                  label-class='addpersonlabel'
                  label-for="p_le_agency"
                >
                  <b-form-select
                    size="lg"
                    :options="getLEOptions"
                    id='p_le_agency'
                    v-model='person.p_le_agency'
                  ></b-form-select>
                </b-form-group>
                <b-form-group
                  label-size='lg'
                  label-class='addpersonlabel'
                  label='Agency Name'
                  label-for='p_le_agency_otherText'
                  :horizontal='false'
                  v-if="person.p_le_agency === 'Other'">
                  <b-form-input
                    size="lg"
                    v-model="person.p_le_agency_otherText"
                    v-if="person.p_le_agency === 'Other'"
                    data-vv-name="Other"
                    v-validate="'required'"
                    data-vv-as="Other">
                  </b-form-input>
                  <span v-show="inputValidationErrors.has('p_le_agency_otherText')" class="text-info">{{ inputValidationErrors.first('p_le_agency_otherText') }}</span>
                </b-form-group>
              </div>
            </transition>

            <b-form-group flush class="pb-2 pl-1">
                <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success" v-model="person.p_perpetrator_known" true-value="Yes" false-value="" name="p_perpetrator_known">Was the Alleged Perpetrator Known?</p-check>
            </b-form-group>

            <transition name="form-fade">
              <div class="sub-group" v-if="person.p_perpetrator_known === 'Yes'">
                <b-form-group label-size='lg' label="Name of Alleged Perpetrator" label-class='addpersonlabel' label-for="p_perpetrator_name">
                  <b-form-input size="lg" type='text' name="p_perpetrator_name" id="p_perpetrator_name" v-model='person.p_perpetrator_name'></b-form-input>
                </b-form-group>
              </div>
            </transition>

            <b-form-group flush class="pb-2 pl-1">
                <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success" v-model="person.p_cps_called" true-value="Yes" false-value="" name="p_cps_called">CPS Called?</p-check>
            </b-form-group>

            <transition name="form-fade">
              <div class="sub-group" v-if="person.p_cps_called === 'Yes'">
                <b-form-group label-size='lg' label-class='addpersonlabel' label='CPS Call Date' label-for='b_cps_call_date' :horizontal='false'>
                  <datepicker
                    input-class="form-control-lg"
                    initial-view="year"
                    v-model='person.p_cps_call_date'
                    id="b_cps_call_date"
                    placeholder="Select Date"
                    :format="this.$dateFormatter"
                    :disabled-dates="{ from: new Date() }"
                  ></datepicker>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' label='CPS ID Number' label-for='p_cps_id_number' :horizontal='false'>
                  <b-form-input size="lg" type='text' v-model='person.p_cps_id_number' id ="p_cps_id_number"></b-form-input>
                </b-form-group>
                <b-form-group label-size='lg' label-class='addpersonlabel' label='CPS Reference Number' label-for='p_cps_reference_number' :horizontal='false'>
                  <b-form-input size="lg" type='text' v-model='person.p_cps_reference_number' id="p_cps_reference_number"></b-form-input>
                </b-form-group>
              </div>
            </transition>

            <!-- CAC -->
            <b-form-group flush class="pb-2 pl-1">
                <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success"
                  v-model="person.p_cac_interview"
                  true-value="Yes"
                  false-value=""
                  name="p_cac_interview">CAC Interview?</p-check>
            </b-form-group>

            <transition name="form-fade">
              <div class="sub-group" v-if="person.p_cac_interview === 'Yes'">
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Interview Date' label-for='p_cac_call_date' :horizontal='false'>
                  <datepicker
                    input-class="form-control-lg"
                    initial-view="year"
                    v-model='person.p_cac_call_date'
                    id="p_cac_call_date"
                    placeholder="Select Date"
                    :format="this.$dateFormatter"
                    :disabled-dates="{ from: new Date() }"
                  ></datepicker>
                </b-form-group>

                <b-form-group label-size='lg' label="CAC Agency" label-class='addpersonlabel' label-for="p_cac_agency">
                  <v-select
                    id='p_cac_agency'
                    :options="getCacOptions"
                    v-model="person.p_cac_agency"
                    placeholder="Search"
                    style="width: 600px"
                  >
                  </v-select>
                </b-form-group>

                <b-form-group flush class="pb-2 pl-1">
                  <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success"
                    v-model="person.p_outcry"
                    true-value="Yes"
                    false-value=""
                    name="p_outcry">Outcry Made?
                  </p-check>
                </b-form-group>
              </div>
            </transition>

            <!-- CSEY Advocate -->
            <b-form-group flush class="pb-2 pl-1">
                <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success"
                  v-model="person.p_csey_advocate_called"
                  true-value="Yes"
                  false-value=""
                  name="p_csey_advocate_called">CSEY Advocate Called?</p-check>
            </b-form-group>

            <transition name="form-fade">
              <div class="sub-group" v-if="person.p_csey_advocate_called === 'Yes'">
                <b-form-group label-size='lg' label-class='addpersonlabel' label='CSEY Advocate Call Date' label-for='p_csey_advocate_called_date' :horizontal='false'>
                  <datepicker
                    input-class="form-control-lg"
                    initial-view="year"
                    v-model='person.p_csey_advocate_called_date'
                    id="p_csey_advocate_called_date"
                    placeholder="Select Date"
                    :format="this.$dateFormatter"
                    :disabled-dates="{ from: new Date() }"
                  ></datepicker>
                </b-form-group>

                <b-form-group label-size='lg' label-class='addpersonlabel' label='CSEY Agency/Contact ' label-for='p_csey_advocate_called_contact' :horizontal='false'>
                  <b-form-input size="lg" type="text" id='p_csey_advocate_called_contact' name="p_csey_advocate_called_contact" v-model='person.p_csey_advocate_called_contact'></b-form-input>
                </b-form-group>

              </div>
            </transition>

            <!-- Gang Affiliation -->
            <b-form-group flush class="pb-2 pl-1">
              <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success" v-model="person.p_gang_affiliation" true-value="Yes" false-value="" name="p_gang_affiliation">Gang Affiliation?</p-check>
            </b-form-group>

            <transition name="form-fade">
              <div class="sub-group" v-if="person.p_gang_affiliation === 'Yes'">
                <b-form-group label-size='lg' label-class='addpersonlabel' label='Gang Name ' label-for='p_gang_description' :horizontal='false'>
                  <b-form-input size="lg" type="text" id='p_gang_description' name="" v-model='person.p_gang_description'></b-form-input>
                </b-form-group>
                <!-- Added Gang County Location -->
                <b-form-group label-size='lg' label="Location by County / Parish" label-class='addpersonlabel' label-for="p_gang_county">
                  <b-form-select
                    id='p_gang_county'
                    label="value"
                    :options="countyOrParishOptions"
                    v-model="person.p_gang_county"
                    placeholder="Search"></b-form-select>
                </b-form-group>
              </div>
            </transition>

            <b-form-group flush class="pb-2 pl-1">
                <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success" v-model="person.p_tattoos" true-value="Yes" false-value="" name="p_tattoos">Tattoos?</p-check>
            </b-form-group>

            <transition name="form-fade">
              <div class="sub-group" v-if="person.p_tattoos === 'Yes'">
                <b-form-group  label-size='lg' label-class='addpersonlabel' label='Tattoo Description' label-for='p_tattoo_description' :horizontal='false'>
                  <b-form-input size="lg" type='text' v-model='person.p_tattoo_description' id="p_tattoo_description"></b-form-input>
                </b-form-group>
              </div>
            </transition>

            <b-form-group flush class="pb-2 pl-1">
              <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain"
                color="success"
                v-model="person.p_runaway"
                true-value="Yes"
                false-value=""
                name="p_runaway">Repeat Runaway?
              </p-check>
            </b-form-group>

            <transition name="form-fade">
              <div class="sub-group" v-if="person.p_runaway === 'Yes'">
                <b-form-group
                  label-size='lg'
                  label-class='addpersonlabel'
                  label='Runaway Frequency'
                  label-for='p_runaway_frequency'
                  :horizontal='false'
                >
                  <b-form-select size="lg" :options="runawayOptions" id='p_runaway_frequency' v-model='person.p_runaway_frequency'></b-form-select>
                </b-form-group>
              </div>
            </transition>

            <b-form-group flush class="pb-2 pl-1">
                <p-check large class="p-success p-round h5 p-0 m-0 p-smooth p-plain" color="success" v-model="person.p_substance_use" true-value="Yes" false-value="" name="p_substance_use">Substance Use</p-check>
            </b-form-group>

            <transition name="form-fade">
              <div class="sub-group" v-if="person.p_substance_use === 'Yes'">
                <b-form-group  label-size='lg' label-class='addpersonlabel' label='Substance Use Description ' label-for='p_substance_use_description' :horizontal='false'>
                  <b-form-input size="lg"  id='p_substance_use_description' v-model='person.p_substance_use_description'></b-form-input>
                </b-form-group>
              </div>
            </transition>

            <b-form-group flush class="pb-2 pl-1">
                <p-check large
                  class="p-success p-round h5 p-0 m-0 p-smooth p-plain"
                  color="success"
                  v-model="person.p_social_media"
                  true-value="Yes"
                  false-value=""
                  name="p_social_media"
                >Social Media Involved</p-check>
            </b-form-group>

            <transition name="form-fade">
              <div class="sub-group" v-if="person.p_social_media === 'Yes'">
                <b-form-group
                  label-size='lg'
                  label-class='addpersonlabel'
                  label='Social Media Involved Description'
                  label-for='d_social_media' :horizontal='false'>
                    <b-form-input size="lg" id='d_social_media' v-model="person.d_social_media"></b-form-input>
                </b-form-group>
              </div>
            </transition>
          </b-col>
        </b-row>
      </b-card>
    </b-tab>



      <!-- <b-tab title="Case Notes">
        <b-card style="border: none">
            <b-row>
              <b-col>
                <b-list-group v-for="note in notes" :key="note.id" flush>
                    <b-list-group-item @click="viewNoteModal(note)">
                        <a href="" @click.prevent class="concl_">
                          <strong class="case-note-title">{{ note.title }}</strong> - {{ $moment(note.customDate).format('MM/DD/YYYY') }}
                        </a>
                    </b-list-group-item>
                </b-list-group>
                <b-button @click="addNoteModal" type="button" variant="primary" class="float-right">Add Case Note</b-button>
                <add-note-modal v-if="addNoteActive" :personId="this.personId" @modalClose="closeAddNoteModal"></add-note-modal>
                <view-note-modal v-if="viewNoteActive" :note="this.viewNote" @modalClose="closeViewNoteModal"></view-note-modal>
              </b-col>
            </b-row>
        </b-card>
      </b-tab> -->
    </b-tabs>
      <b-modal v-if="showVictimStatusModal" scrollable title='Victim Status' :visible=showVictimStatusModal @ok="handleVictimStatusModal" header-bg-variant="success" header-text-variant="light" size="md" centered id="modal" ok-only>
        <template #modal-header-close>
      <h4>X</h4>
    </template>
            <p>{{this.stateName === 'LA' ? 'A trafficking event is considered "confirmed" when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in La. RS 14:46.2, La. RS 14:46.3, or the federal Trafficking Victims Protection Act (TVPA). The supporting evidence must be more than just an allegation or suspicion.' : 'A trafficking event is considered "confirmed" when evidence supports the conclusion that the individual is a victim of human trafficking, as defined in the federal Trafficking Victims Protection Act (TVPA). The supporting evidence must be more than just an allegation or suspicion.'}}</p>
            <p>A trafficking event is considered "suspected" when specific information regarding the individual and the surrounding circumstances creates a reasonable belief that the individual is a victim of human trafficking. The presence of one or more risk factors does not necessarily equate to a "suspected" case of trafficking.</p>
            <p>
              An individual is considered “at-risk” for human trafficking when the individual displays one or more risk factors of human trafficking.
              This includes but is not limited to: system-involvement, past history of abuse, homelessness or frequent runaway behavior,
              substance abuse disorder, among other factors. The presence of one or more risk factors for human trafficking, by itself,
              does not equate to a confirmed or suspected case of human trafficking.
            </p>
            <p>
              An individual’s victim status is considered “unknown” when the agency lacks sufficient information to classify the individual as confirmed,
              suspected, or at-risk for human trafficking at this time. Upon gaining additional information on the individual,
              the individual’s victim status should be updated.
            </p>
            <p><strong>Note</strong>: Most screening tools are not diagnostic tools. If a screening for human trafficking has been conducted on an individual, the results of the screening may not be sufficient alone to determine victim status.</p>
      </b-modal>
      <b-modal v-if="showServicesModal" scrollable title='Services' :visible=showServicesModal @ok="handleServicesModal" header-bg-variant="success" header-text-variant="light" size="md" centered id="modal" ok-only>
        <template #modal-header-close>
          <h4>X</h4>
        </template>
        <p><strong>Addiction Recovery Services</strong> – Select if victim received addiction recovery services, including rehab, detox, or an out-patient program.</p>
        <p><strong>Apply for Federal/State Benefits</strong> - Select if the victim was provided guidance or assistance in applying for federal or state benefits (e.g. WIC, SNAP, etc.).</p>
        <p><strong>Budget or Financial Literacy</strong> - Select if victim received budgeting assistance and/or was provided information related to financial literacy.</p>
        <p><strong>Case Management</strong> - Select if the victim received case management support.</p>
        <p><strong>Child Care</strong> - Select if the victim was provided assistance in caring for their child(ren).</p>
        <p><strong>Education</strong> - Select if the victim was provided with educational services, such as a GED program.</p>
        <p><strong>Family Unification</strong> - Select if the victim was provided services that assisted them in connecting with or returning to family members from whom they had been separated.</p>
        <p><strong>Food/Clothing/Hygiene</strong> - Select if victim received direct assistance for food or groceries, clothing, shoes, and/or hygiene products.</p>
        <p><strong>Forensic Interview</strong> - Select if victim was involved in a forensic interview.</p>
        <p><strong>Health</strong> - Select if the victim was provided with medical care or treatment.</p>
        <p><strong>Housing</strong> - Select if the victim was provided with shelter/housing.</p>
        <p><strong>Job Training</strong> - Select if the victim was provided services meant to assist them in gaining employment.</p>
        <p><strong>Legal Services</strong> - Select if the victim was provided with legal services, such as consultation or representation.</p>
        <p><strong>Mental Health</strong> - Select if the victim was provided with mental health services (e.g. counseling, therapy, etc.).</p>
        <p><strong>Mentorship</strong> - Select if victim was provided mentorship or peer-to-peer support.</p>
        <p><strong>Multidisciplinary Team Staffing</strong> - Select if a multidisciplinary team was formed in support of the victim.</p>
        <p><strong>Other Financial Assistance</strong> - Select if victim received other financial assistance.</p>
        <p><strong>Parenting or Pregnancy Services</strong> - Select if victim received parenting or pregnancy services, including parenting classes.</p>
        <p><strong>Personal Documents Assistance</strong> - Select if victim received assistance in obtaining any personal documentation, such as identification, social security card, birth certificate, citizenship documents, passports, etc.</p>
        <p><strong>Referral to Community Services</strong> - Select if the victim was referred to other service providers within the community.</p>
        <p><strong>Safety Planning</strong> - Select if victim was provided safety planning.</p>
        <p><strong>Translation or ESL Services</strong> - Select if victim was provided translation assistance or ESL services.</p>
        <p><strong>Transportation</strong> - Select if victim was provided transportation by the agency, including bus passes, plane tickets, ride-share trips.</p>
        <p><strong>Victim Advocacy</strong> - Select if victim was provided victim advocacy for any criminal or civil cases. Note: this does not refer to legal representation.</p>
        <p><strong>Victim Compensation</strong> - Select if the victim was provided with victim compensation.</p>
        <p><strong>Other Services</strong> - Specify any other service provided that is not included in one of the previous categories.</p>
      </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

import addNoteModal from '@/views/t1/AddNoteModal'
import viewNoteModal from '@/views/t1/ViewNoteModal'
import PersonVictimInfoForm from '@/views/t1/PersonVictimInfoForm'
import { victimInfo as VictimInfoModel } from '@/api/models'

export default {
  name: 'personform',
  components: {
    addNoteModal,
    viewNoteModal,
    PersonVictimInfoForm
  },
  props: {
    person: {
      type: Object,
      default: () => { return {} }
    },
    chooseOrganization: false,
    victimInfo: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    ...mapGetters({
      authenticatedUserMemberships: 'authenticatedUserMemberships',
      notes: 'getPersonNotes',
      orientation_options: 'getOrientationOptions',
      race_options: 'getRaceOptions',
      discharge_options: 'getDischargeOptions',
      services_provided: 'getServicesProvided',
      ethnicity_options: 'getEthnicityOptions',
      immigration_options: 'getImmigrationOptions',
      victim_status_options: 'getVictimStatusOptions',
      gender_identity: 'getGenderIdentityOptions',
      gender_options: 'getGenderOptions',
      months: 'getMonths',
      countries: 'getCountries', // ISO-3166-1-Alpha-3Codes data
      stateAndAbbrev: 'getStateAndAbbrev',
      educationTypes: 'getEducationTypeOptions',
      povertyOptions: 'getPovertyLineOptions',
      leOptions: 'getLeCalledOptions',
      laLeOptions: 'getLALeCalledOptions',
      guardianOptions: 'getGuardianOptions',
      presentingOffenseOptions: 'getPresentingOffenseOptions',
      gradeLevelOptions: 'getGradeLevelOptions',
      confirmationSourceOptions: 'getConfirmationSourceOptions',
      runawayOptions: 'getRunawayOptions',
      cacOptions: 'getCacOptions',
      laCacOptions: 'getLACacOptions',
      disabilityOptions: 'getDisabilityOptions',
      yesNoUnknownOptions: 'getYesNoUnknownOptions',
      counties: 'getCountyData',
      parishes: 'getLAParishData',
      traffickingTypesTX: 'getTraffickingTypesTX',
      traffickingTypesLA: 'getTraffickingTypesLA',
      sexTraffickingMeans: 'getSexTraffickingMeans',
      laborTraffickingMeans: 'getLaborTraffickingMeans',
      industryRelatedOptions: 'getIndustryRelatedOptions',
      userCurrentContext: 'userCurrentContext',
      personVictimInfo: 'getPersonVictimInfo'
    }),
    countyOrParishOptions () {
      switch (this.stateName) {
        case 'TX':
          return this.counties
        case 'LA':
          return this.parishes
        default:
          return []
      }
    },
    countyOrParishOptionsTrafficking () {
      switch (this.stateName) {
        case 'TX':
          var newCountyArray = this.counties.concat([{ 'text': 'Multiple', 'value': 'Multiple' }, { 'text': 'Out of State', 'value': 'Out of State' }, { 'text': 'Out of Country', 'value': 'Out of Country' }, { 'text': 'Unknown', 'value': 'Unknown' }])
          return newCountyArray
        case 'LA':
          var newParishesArray = this.parishes.concat([{ 'text': 'Multiple', 'value': 'Multiple' }, { 'text': 'Out of State', 'value': 'Out of State' }, { 'text': 'Out of Country', 'value': 'Out of Country' }, { 'text': 'Unknown', 'value': 'Unknown' }])
          return newParishesArray
        default:
          return []
      }
    },
     countyOrParishOptionsOrigin () {
      switch (this.stateName) {
        case 'TX':
          var countyOriginArray = this.counties.concat([{ 'text': 'Out of State', 'value': 'Out of State' }, { 'text': 'Out of Country', 'value': 'Out of Country' }])
          return countyOriginArray
        case 'LA':
          var parishOriginArray = this.parishes.concat([{ 'text': 'Out of State', 'value': 'Out of State' }, { 'text': 'Out of Country', 'value': 'Out of Country' }])
          return parishOriginArray
        default:
          return []
      }
    },
    getLEOptions () {
      switch (this.stateName) {
        case 'LA':
          return this.laLeOptions
        case 'TX':
        default:
          return this.leOptions
      }
    },
    getCacOptions () {
      switch (this.stateName) {
        case 'LA':
          return this.laCacOptions
        case 'TX':
        default:
          return this.cacOptions
      }
    },
    getTraffickingTypes () {
      switch (this.stateName) {
        case 'LA':
          return this.traffickingTypesLA
        case 'TX':
        default:
          return this.traffickingTypesTX
      }
    },
    getNonUSCountries () {
      let array = this.countries.filter(country => country.text !== 'United States')
      // console.log(array)
      return array
    },
    isAtRiskOrUnknown () {
      return this.person.b_confirmed === 'At-Risk' ||
        this.person.b_confirmed === 'Unknown'
    },
    compiledVictimInfo () {
      return this.newVictimInfo.concat(this.personVictimInfo)
    },
    isAllowedToAddTypeOfTrafficking () {
      return this.compiledVictimInfo.length < 3
    },
    isCareCoordinator () {
      return this.userCurrentContext &&
        this.userCurrentContext.userMember &&
        this.userCurrentContext.userMember.isCareCoordinator
    },
    isOrgManager () {
      return this.userCurrentContext &&
        this.userCurrentContext.userMember &&
        this.userCurrentContext.userMember.isManager
    }
  },
  watch: {
    authenticatedUserMemberships: function (newValue) {
      this.initializeOwningOrganization(newValue)
      const owningOrg = this.person.organizationOwner
      if (owningOrg) {
        this.stateName = owningOrg.mailingStateAbbreviation
      } else {
        this.stateName = this.userCurrentContext.userMember.morganization.mailingStateAbbreviation
      }
    },
    compiledVictimInfo: {
      handler (newValue) {
        const populatedInfo = newValue.filter((victimInfo) => victimInfo.b_type_of_trafficking)
        this.$emit('updateVictimInfo', populatedInfo)
      },
      deep: true,
      immediate: true
    },
    person: function (newValue) {
      if (newValue._id) {
        this.personId = newValue._id
      }
    },
    selectedServices: {
      handler (newValue) {
        this.person.selectedServices = newValue
      },
      deep: true
    }
  },

  inject: ['$validator'],

  data: function () {
    const tabIndexInQuery = parseInt(this.$route.query && this.$route.query.tabIndex)
    return {
      showVictimStatusModal: false,
      showServicesModal: false,
      t1plus: '',
      errors: [],
      month: '',
      day: '',
      year: '',
      tabIndex: tabIndexInQuery || 0,
      selectedServices: [],
      servicesWithNoEntryDate: true,
      servicesWithNoEntryDateWarn: false,
      newVictimInfo: [],

      // Note modal
      personId: 0,
      addNoteActive: false,
      viewNoteActive: false,
      viewNote: {},
      selectedOrganizationOwner: 0,
      stateName: ''
    }
  },

  methods: {
    addAnotherTypeOfTrafficking () {
      this.newVictimInfo.push(cloneDeep(VictimInfoModel))
    },
    formatter (value) {
      let newValues = Math.round(value)
      if (newValues > 100) {
        return 100
      } else if (newValues < 0) {
        return 0
      } else {
        return newValues
      }
    },
    handleVictimStatusModal: function () {
      this.showVictimStatusModal = !this.showVictimStatusModal
    },
    handleServicesModal: function () {
      this.showServicesModal = !this.showServicesModal
    },
    isActiveOrganization: function (umo) {
      return _.get(umo, 'morganization.id', false) === this.selectedOrganizationOwner
    },
    updateStateAbbr () {
      this.organization.mailingStateAbbreviation = _.result(_.find(this.stateAndAbbrev, obj => {
        return obj.text === this.organization.mailingState
      }), 'value')
    },
    mailingStateOptions () {
      return _.sortBy(this.stateAndAbbrev, 'text').map((state) => {
        return {value: state.text, text: state.text}
      })
    },
    initializeOwningOrganization: function (memberships) {
      let umo

      if (memberships.length === 1) {
        umo = memberships[0]
      } else {
        const user = this.$auth.user()
        const primaryOrganization = _.get(user, 'primaryOrganization.id', false)
        umo = memberships.find((umo) => umo.morganization.id === primaryOrganization)
      }

      if (umo) {
        this.assignOrganization(umo)
      }
    },
    handleOwningOrganizationSelection: function (umo) {
      if (umo) {
        this.assignOrganization(umo)
      }
    },
    assignOrganization: function (umo) {
      const orgId = _.get(umo, 'morganization.id')
      if (orgId) {
        this.selectedOrganizationOwner = orgId
      }
    },
    // updateConfirmed: function () {
    //   if (this.person.b_confirmation_LE || this.person.b_confirmation_Victim || this.person.b_confirmation_CPS || this.person.b_confirmation_Expert || this.person.b_confirmation_Other) {
    //     this.person.b_confirmed = 'Yes'
    //   } else {
    //     this.person.b_confirmed = 'Not Observed'
    //   }
    // },
    addNoteModal: function () {
      this.addNoteActive = true
    },
    closeAddNoteModal: function () {
      this.addNoteActive = false
    },
    viewNoteModal: function (note) {
      this.viewNoteActive = true
      this.viewNote = note
    },
    closeViewNoteModal: function () {
      this.viewNoteActive = false
      this.viewNote = {}
    },
    servicesWithNoEntryDateClick () {
      // If someone tries to select a service without entering an entry date, show warning
      if (this.servicesWithNoEntryDate === true) {
      this.servicesWithNoEntryDateWarn = true
      }
    }
  },

  mounted () {
    var tab = this.$route.params.tab
    // console.log(tab, this.person.b_confirmed)
    if (tab === 'supplement') {
      if (this.person.b_confirmed) {
        this.tabIndex = 3
      } else {
         this.tabIndex = 2
      }
    }
    if (tab === 'victiminformation') {
      this.tabIndex = 1
    }
    // TODO: below is for backward compatibility, to remove after db changes
    if (this.person.p_grade_level === 'GED') {
      this.person.p_grade_level = 'High school diploma/GED'
    }

    if (this.person.s_selected_services) {
      this.selectedServices = this.person.s_selected_services.split(',')
    }

    this.$watch(() => {
      if (this.$refs.s_program_entry_dateRef) {
        if (this.$refs.s_program_entry_dateRef.value) {
          this.servicesWithNoEntryDate = false
          this.servicesWithNoEntryDateWarn = false
        } else {
          this.servicesWithNoEntryDate = true
        }
      }
    })
  },

  async created () {
    this.$store.commit('SET_PERSON_VICTIM_INFO', [])
    const owningOrg = this.person.organizationOwner
    if (owningOrg) {
      this.stateName = owningOrg.mailingStateAbbreviation
    } else {
      this.stateName = this.userCurrentContext.userMember.morganization.mailingStateAbbreviation
    }
    this.initializeOwningOrganization(this.authenticatedUserMemberships)
    if (this.person._id) {
      await this.$store.dispatch('getPersonVictimInfo', {
        person: this.person._id
      })
    }
    if (!this.personVictimInfo.length) {
      this.newVictimInfo.push(cloneDeep(VictimInfoModel))
    }
  }
}
</script>

<style>
  .form-control-lg.autocomplete__box {
    height: calc(2.64062rem + 2px);
  }

  .form-control-lg > .autocomplete__icon {
    height: calc(2.64062rem - 12px);
    width: 20px;
  }

  .list-group-item.active > a {
    color: #fff;
  }

  .vdp-datepicker__clear-button:after {
    content: 'Clear Date';
    padding: 5px;
    color: #198eb7;
  }
</style>



// WEBPACK FOOTER //
// src/views/t1/PersonForm.vue